import { createFileRoute } from '@tanstack/react-router';

import { PersonalityTraitsStep } from '@/features/onboarding/components/steps/lf/personalityTraitsStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/personality-traits',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <PersonalityTraitsStep />;
}
